/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} Ui_Thresholds_Birth_Year_RangeInputs */

const en_ui_thresholds_birth_year_range = /** @type {(inputs: Ui_Thresholds_Birth_Year_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Between ${i?.min} and ${i?.max}`)
};

const de_ui_thresholds_birth_year_range = /** @type {(inputs: Ui_Thresholds_Birth_Year_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zwischen ${i?.min} und ${i?.max}`)
};

/**
* | output |
* | --- |
* | "Between {min} and {max}" |
*
* @param {Ui_Thresholds_Birth_Year_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_birth_year_range = /** @type {((inputs: Ui_Thresholds_Birth_Year_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Birth_Year_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_birth_year_range(inputs)
	return de_ui_thresholds_birth_year_range(inputs)
});